import { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import {
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  FormCheckbox,
} from "shards-react";
import Cleave from "cleave.js/react";

const SignatureFields = ({
  fieldsNames,
  isNewEnvelope,
  extractedFields,
  workstep,
  fieldDisplayNames,
  formInputClasses,
  handleInputChange,
  signatureType,
  modulesOnFinish,
  // approved,
  // modifyFieldValue
}) => {
  const [needsSmsAuth, setNeedsSmsAuth] = useState(false);
  const esignModule = modulesOnFinish?.filter(
    (module) => module["-name"] === "synop.esign"
  )[0];

  const showSmsToggle =
    esignModule &&
    esignModule["-synopSMSAuth"] !== undefined &&
    esignModule["-synopSMSAuth"] !== null
      ? esignModule["-synopSMSAuth"]
      : false;

  useEffect(() => {
    const smsAuthToggleState = workstep && workstep?.sms_auth;
    setNeedsSmsAuth(smsAuthToggleState);
  }, [workstep]);

  const mobilePattern = useMemo(() => "^\\+\\d+[ 0-9]{7,}$", []);
  const emailPattern = useMemo(() => "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$", []);

  const handleToggle = () => {
    setNeedsSmsAuth((needsSmsAuth) => !needsSmsAuth);
    handleInputChange("sms_auth", !needsSmsAuth, "", workstep.workstep_id);
  };

  const getIsValid = (fieldsName) => {
    if (workstep) {
      return workstep[fieldsName] && workstep[fieldsName]
        ? { valid: "true" }
        : { invalid: "true" };
    }
    return extractedFields[fieldsName] && extractedFields[fieldsName].word
      ? { valid: "true" }
      : { invalid: "true" };
  };

  const getDisplayName = (fieldsName, index) => {
    if (workstep) {
      return fieldDisplayNames[index];
    }
    return extractedFields[fieldsName]
      ? extractedFields[fieldsName].displayName
      : fieldDisplayNames[index];
  };

  const getvalue = (fieldsName) => {
    if (workstep) {
      return workstep[fieldsName];
    }
    return extractedFields[fieldsName] ? extractedFields[fieldsName].word : "";
  };

  const onChange = (e, fieldsName, index) => {
    if (workstep) {
      handleInputChange(
        fieldsName,
        e.target.value,
        fieldDisplayNames[index],
        workstep.workstep_id
      );
    } else {
      handleInputChange(fieldsName, e.target.value, fieldDisplayNames[index]);
    }
  };

  return !isNewEnvelope ? (
    <></>
  ) : (
    <>
      {fieldsNames &&
        fieldsNames.map((fieldsName, index) => {
          const isValid = getIsValid(fieldsName);
          return (
            <InputGroup key={index} className="col p-0 mb-4">
              <InputGroupAddon type="prepend">
                <InputGroupText className="text-dark">
                  {getDisplayName(fieldsName, index)}
                </InputGroupText>
              </InputGroupAddon>
              <Cleave
                id="extracted-value"
                className="extbg-white text-right cursor-default form-control"
                placeholder={
                  fieldsName === "mobile" ? "+XX XXXXXXXXX" : "Bitte Eingeben"
                }
                data-field={fieldsName}
                options={formInputClasses[fieldsName]}
                onChange={(e) => onChange(e, fieldsName, index)}
                value={getvalue(fieldsName)}
                {...isValid}
                required={
                  fieldsName === "mobile" &&
                  (signatureType === undefined ||
                    signatureType === "untrusted") &&
                  !needsSmsAuth
                    ? false
                    : true
                }
                {...(fieldsName === "mobile" &&
                  signatureType !== undefined &&
                  (signatureType === "trusted" || needsSmsAuth) && {
                    pattern: mobilePattern,
                    title: `Das Format : +XX XXXXXXXX`,
                  })}
                {...(fieldsName === "email" && {
                  pattern: emailPattern,
                  title: `Bitte geben Sie eine gültige E-Mail Adresse ohne Leerzeichen ein`,
                })}
              />
              {/* {!approved && (
							<InputGroupAddon type='append'>
								<Button theme='warning' className='change-field-value' data-field={fieldsName} onClick={(e) => modifyFieldValue(e, fieldDisplayNames[index])}>
									<i className='fa fa-crosshairs' />
								</Button>
							</InputGroupAddon>
						)} */}
            </InputGroup>
          );
        })}
      {showSmsToggle && (
        <FormCheckbox
          toggle
          small
          checked={needsSmsAuth}
          onChange={handleToggle}
          className="custom-toggle-sms"
          data-cy="sms-auth-checkbox"
        >
          {`SMS-Authentifizierung ist ${needsSmsAuth ? "" : "nicht "}aktiv`}
        </FormCheckbox>
      )}
    </>
  );
};

export default SignatureFields;
